import * as Dialog from "@radix-ui/react-dialog";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../../../GlobalContext";

export default function VolunteerDutyModal({
  isOpen,
  onClose,
  volunteer,
  updateVolunteerDutyTypeApi,
  onUpdated,
}) {
  const { AdminId } = useGlobalContext();

  const [form, setForm] = useState({
    volunteerType: "",
    startTime: "",
    endTime: "",
  });

  useEffect(() => {
    if (isOpen && volunteer) {
      setForm({
        volunteerType: volunteer.volunteerType || "",
        startTime: volunteer.start_time || "",
        endTime: volunteer.end_time || "",
      });
    }
  }, [isOpen, volunteer]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async () => {
    if (!form.volunteerType) {
      toast.error("Please select volunteer type");
      return;
    }

    if (!form.startTime || !form.endTime) {
      toast.error("Please select both start and end time");
      return;
    }

    const payload = {
      adminId: AdminId,
      userid: volunteer.volunteer_code,
      volunteerType: form.volunteerType,
      startTime: form.startTime,
      endTime: form.endTime,
    };

    const success = await updateVolunteerDutyTypeApi(payload);

    if (success) {
      onUpdated?.();
      onClose();
    }
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
        <Dialog.Content className="bg-white p-6 rounded-md max-w-md w-full fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 space-y-4">

          <Dialog.Title className="text-lg font-semibold">
            Update Volunteer Duty
          </Dialog.Title>

          <select
            name="volunteerType"
            value={form.volunteerType}
            onChange={handleChange}
            className="border p-2 rounded w-full"
          >
            <option value="">Select Volunteer Type</option>
            <option value="full_time">Full Time</option>
            <option value="part_time">Part Time</option>
          </select>

          <div className="grid grid-cols-2 gap-2">
            <input
              type="time"
              name="startTime"
              value={form.startTime}
              onChange={handleChange}
              className="border p-2 rounded"
            />
            <input
              type="time"
              name="endTime"
              value={form.endTime}
              onChange={handleChange}
              className="border p-2 rounded"
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <Dialog.Close asChild>
              <button className="bg-gray-200 px-4 py-2 rounded text-sm">
                Cancel
              </button>
            </Dialog.Close>
            <button
              onClick={handleUpdate}
              className="bg-green-600 text-white px-4 py-2 rounded text-sm"
            >
              Update Duty
            </button>
          </div>

        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
